import React, { FC } from 'react'

interface CopyrightI {
  title: string
}
const Copyright: FC<CopyrightI> = ({ title }) => (
  <div id="copyright">
    <ul>
      <li>© {title}</li>
      <li>
        Designed by: <a href="https://heyayush.com">HEYAYUSH.COM</a>
      </li>
    </ul>
  </div>
)

export default Copyright
